import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import WebMailBottom from '@/components/common/WebMailBottom.vue'
import MonthView from '@calendar/components/View/MonthView.vue'
import WeekView from '@calendar/components/View/WeekView.vue'
import DayView from '@calendar/components/View/DayView.vue'
import RecurringScheduleModal from '@calendar/components/Modals/RecurringScheduleModal.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as types from '@calendar/store/types'
import { EnumCalendarViewType } from '../types'
import api from '@calendar/api'
@Component({
    components: { 
        WebMailBottom,
        MonthView,
        WeekView,
        DayView,
        RecurringScheduleModal
    },
    methods: {
        ...mapActions({
            loadFolderTree: types.FOLDER_LOAD_TREE,
            loadEventList: types.CALENDAR_EVENT_LOAD_LIST,
            setCalendarMode: types.CALENDAR_VIEWMODE_CHANGE,
            loadCalendarPrev: types.COMMON_CALENDAR_PREV,
            loadCalendarNext: types.COMMON_CALENDAR_NEXT,
            changeDate: types.COMMON_CHANGE_DATE
        }),
        ...mapMutations({
            setCalendarItem: types.CURRENT_CALENDAR_ITEM,
            setAppointment: types.CALENDAR_CURRENT_APPOINTMENT,
        })
    },
    computed: mapGetters({
        currentDate: types.COMMON_DATE_CURRENT
    })

})
export default class CalendarContainer extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: String, default: 'month' }) mode!: string

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loadFolderTree!: () => Promise<any>;
    loadEventList!: (viewType: string) => void
    setCalendarMode!: (mode: string) => void
    loadCalendarPrev!: (item: calendar.DateItem) => void
    loadCalendarNext!: (item: calendar.DateItem) => void
    changeDate!: (item: calendar.DateItem) => void

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setCalendarItem!: (item: calendar.CalendarItem) => void
    setAppointment!: (appointment: any) => void

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    currentDate!: calendar.DateItem

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    showRecurringScheduleModal:boolean = false
    selectItem!: calendar.CalendarItem
    AppointmentType: string = 'OccurrenceOrException'

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    @Watch('mode')
    onChangedMode(newValue: string) {
        this.setCalendarMode(newValue)
    }

    prev() {
        this.loadCalendarPrev(this.currentDate)
    }

    next() {
        this.loadCalendarNext(this.currentDate)
    }

    viewSchedule(eventItem: calendar.CalendarItem) {
        if(eventItem.id && eventItem.id != null) {
            //반복일정이면
            if (eventItem.appointmentType == 'Occurrence' || eventItem.appointmentType == 'Exception') {
                this.showRecurringScheduleModal = true;
                this.selectItem = eventItem;
            }
            //반복일정 아니면(Single)
            else {
                this.setCalendarItem(eventItem);
                this.$router.push({
                    path: '/calendar/read',
                    query: { itemid: eventItem.id, target: eventItem.target, bname: this.$route.name + '' }
                })
            }
        }        
    }

    cAppointment(option: string) {
        if (option === 'this') {           
            this.AppointmentType = 'OccurrenceOrException';
            this.setAppointment(this.AppointmentType);
            this.beforeView();
        }
        else if (option === 'all') {          
            this.AppointmentType = 'Master';
            this.setAppointment(this.AppointmentType);
            this.beforeView();
        }
    }

    beforeView() {
        this.setCalendarItem(this.selectItem);
        if (this.selectItem != null) {
            const _target = this.selectItem.target;
            if (this.AppointmentType == 'OccurrenceOrException') {
                if (this.selectItem.isEWS) {
                    this.$router.push({
                        path: '/calendar/read',
                        query: {
                            itemid: this.selectItem.id,
                            target: _target,
                            bname: this.$route.name + '',
                            occitem: JSON.stringify((this.selectItem)),
                        }
                    });
                } else {
                    if (this.selectItem.appointmentType == 'Occurrence') {
                        this.$router.push({
                            path: '/calendar/read',
                            query: {
                                itemid: this.selectItem.db_masterID.toString(),
                                target: _target,
                                appoint: this.AppointmentType,
                                occitem: JSON.stringify((this.selectItem)),
                            }
                        })
                    } else {
                        this.$router.push({
                            path: '/calendar/read',
                            query: {
                                itemid: this.selectItem.id.toString(),
                                target: _target,
                                appoint: this.AppointmentType,
                                occitem: JSON.stringify((this.selectItem)),
                            }
                        })
                    }
                }
            }
            //master
            else {
                if (this.selectItem.isEWS) {
                    api.ews_calendar.getRecurringMasterID(this.selectItem.id)
                        .then((masterID: string) => {                            
                            return this.$router.push({
                                path: '/calendar/read',
                                query: {
                                    itemid: masterID,
                                    target: _target,
                                }
                            });
                        });
                } else {                   
                    return this.$router.push({
                        path: '/calendar/read',
                        query: {
                            itemid: this.selectItem.db_masterID.toString(),
                            target: _target,
                        }
                    });
                }
            }
        }
    }   

    viewMore(item: calendar.DateItem) {
        this.changeDate(item)
        this.$emit('modeChange', 'day')
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.loadFolderTree().then(() => {
            this.loadEventList(EnumCalendarViewType.Month)
        })
    }
}
